<template>
  <div>
    <VueperSlides
      v-if="carousel"
      :infinite="carousel?.infinite"
      :arrows="carousel?.arrows && !isTablet"
      :duration="carousel?.duration"
      :touchable="carousel?.touchable"
      :autoplay="carousel?.autoPlay && validSlides.length > 1"
      :pause-on-hover="carousel?.pauseOnHover"
      :pause-on-touch="carousel?.pauseOnTouch"
      :progress="carousel?.progress"
      :bullets="!isTablet"
      class="h-screen no-shadow overflow-hidden transition-colors duration-1000"
      :style="{ background: slides?.[slideIdx]?.bgColor ?? carousel?.bgColor ?? 'transparent' }"
      fixed-height="100vh"
      @before-slide="beforeSlide"
    >
      <VueperSlide
        v-for="(slide, index) in validSlides"
        :key="index"
        :image="slide?.image"
        :link="slide?.link"
        :openInNew="slide?.openInNew"
        :content="slide?.content"
        :video="(slide?.video?.url || slide?.video?.mp4 || slide?.video?.webm || slide?.video?.ogv || slide?.video?.avi) ? slide?.video : null"
        :duration="slide?.duration"
        class="transition"
      >
        <template v-if="!slide?.video" #content>
          <div class="box-border h-screen overflow-auto p-4 flex flex-wrap items-center justify-center text-center">
            <div v-html="slide.content"></div>
          </div>
        </template>
      </VueperSlide>
      <template #bullet="{ active }">
        <span class="p-4 -mb-8">
          <span
            class="inline-block h-3 rounded-full transition-all w-3"
            :class="active ? '!w-6 bg-[--c-primary-600]' : ' bg-transparent border border-solid border-white'"
          ></span>
        </span>
      </template>
    </VueperSlides>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { VueperSlides, VueperSlide } from 'vueperslides'
import { useWindowSize } from '@vueuse/core'

import type { Carousel, Slide } from '@/views/configuracao/personalizar/components/login/types'
import 'vueperslides/dist/vueperslides.css'

const { width } = useWindowSize()

const props = defineProps<{
  carousels: Carousel[]
}>()

const slides = computed<(Slide & { cIdx: number })[]>(() => {
  let temp = [] as (Slide & { cIdx: number })[]

  props.carousels.forEach((c, cIdx) => {
    c.slides.forEach(s => temp.push({ ...s, cIdx }))
  })

  return temp
})

const validSlides = computed(() => {
  return slides.value?.filter(i => i?.image || i?.content || i?.video?.url || i?.video?.url || i?.video?.mp4 || i?.video?.webm || i?.video?.ogv || i?.video?.avi)
})

const carousel = computed(() => {
  return props.carousels.filter(c => c.active && c.slides.length > 0)[0]
  // return props.carousels.filter(c => c.active && c.slides.length > 0).map((c, cIdx) => {
  //   c.slides.forEach(s => slides.value.push({ ...s, cIdx }))
  //   return c
  // })[0]
})

const slideIdx = ref(0)

const isTablet = computed(() => width.value < 1024)

const beforeSlide = (opt) => {
  const { nextSlide } = opt
  slideIdx.value = nextSlide?.index || 0
}
</script>

<style>
.vueperslide__video {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
</style>